import React from "react";
import { Row, Button } from "antd";
import ActionBtn from "./ActionBtn";

const ActionHeader = ({ pagination, pageSize, selectedRowKeys, setSelectedRowKeys, count, onActionClick }) => {
  return selectedRowKeys.length > 0 ? (
    <Row align="middle" style={{ marginBottom: "20px", height: "2rem", fontSize: "1rem" }}>
      <span>Selected {selectedRowKeys.length} item</span>
      <Button
        type="link"
        onClick={() => {
          setSelectedRowKeys([]);
        }}
      >
        Unselect All
      </Button>

      <ActionBtn
        options={[
          {
            label: "Edit",
            key: "edit",
          },
          {
            label: "",
            key: "2",
          },
        ]}
        onClick={(key) => onActionClick(key)}
      />
    </Row>
  ) : (
    <Row align="middle" style={{ marginBottom: "20px", height: "2rem", fontSize: "1rem" }}>
      <span>
        {(pagination - 1) * pageSize + 1} - {count > pagination * pageSize ? pagination * pageSize : count} of total{" "}
        {count} items
      </span>
    </Row>
  );
};

export default ActionHeader;
